/**
 * Application Configuration
 * 
 * Centralized configuration for the entire application.
 * All environment variables should be accessed through this file.
 */

export const appConfig = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || '',
    timeout: 30000,
  },
  
  auth: {
    authorityUrl: import.meta.env.VITE_AUTH_AUTHORITY_URL || '',
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID || '',
    redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || `${window.location.origin}/auth`,
    postLogoutRedirectUri: import.meta.env.VITE_AUTH_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/postsignout`,
    scope: import.meta.env.VITE_AUTH_SCOPE || 'openid profile email',
  },
  
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || '',
  },
  
  features: {
    enableDebugMode: import.meta.env.DEV,
    enableMockServices: import.meta.env.VITE_USE_MOCK_SERVICES === 'true',
    enableServiceWorker: 'serviceWorker' in navigator,
  },
  
  session: {
    idleTimeoutMinutes: 15,
    tokenRefreshIntervalMinutes: 5,
  },
} as const;

// Type-safe config access
export type AppConfig = typeof appConfig;
